import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { IButtonProps } from '@fluentui/react';
import { useHistory, useLocation } from 'react-router';
import { useEffect, useMemo, useState } from 'react';
import MenuService from '@/services/MenuService';

const _overflowItems: ICommandBarItemProps[] = [];
const overflowProps: IButtonProps = {ariaLabel: 'Más acciones'};

const buildMenuItems = (pathname: string, marketEnabled: boolean, push: (path: string) => void): ICommandBarItemProps[] =>
{
    const baseItems: ICommandBarItemProps[] =
    [
        {
            text: 'Resumen de cartera',
            key: 'portfolio',
            onClick: () => push('/portfolio'),
            className: pathname === '/portfolio' ? 'is-selected' : ''
        },
        {
            text: 'Ficha',
            key: 'file',
            onClick: () => push('/portfolio/file'),
            className: pathname === '/portfolio/file' ? 'is-selected' : ''
        },
        {
            text: 'Órdenes-New',
            key: 'ordersNew',
            onClick: () => push('/portfolio/ordersNew'),
            className: pathname === '/portfolio/ordersNew' ? 'is-selected' : ''
        },
        {
            text: 'Operaciones realizadas',
            key: 'operations',
            onClick: () => push('/portfolio/operations'),
            className: pathname === '/portfolio/operations' ? 'is-selected' : ''
        },
        {
            text: 'Órdenes en curso',
            key: 'orders',
            onClick: () => push('/portfolio/orders'),
            className: pathname === '/portfolio/orders' ? 'is-selected' : ''
        },
        {
            text: 'Información fiscal',
            key: 'fiscal_report',
            onClick: () => push('/portfolio/fiscalReport'),
            className: pathname === '/portfolio/fiscalReport' ? 'is-selected' : ''
        }
    ];

    if(marketEnabled)
    {
        baseItems.push(
        {
            text: 'Mercado',
            key: 'market',
            onClick: () => push('/portfolio/market'),
            className: pathname === '/portfolio/market' ? 'is-selected' : ''
        });
    }

    return baseItems;
};

const PortfolioMenu = () =>
{
    const history = useHistory();
    const location = useLocation();
    const pathname = location.pathname;
    const [isMarketEnabled, setIsMarketEnabled] = useState<boolean>(false);
    const menuItems = useMemo<ICommandBarItemProps[]>(() => buildMenuItems(pathname, isMarketEnabled, history.push), [pathname, isMarketEnabled, history.push]);

    useEffect(() =>
    {
        MenuService.getMarketItemEnable().then(setIsMarketEnabled);
    }, []);

    return(
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" id="main-menu">
                <CommandBar items={menuItems} overflowItems={_overflowItems} overflowButtonProps={overflowProps}
                    ariaLabel="Usa las flechas izquierda y derecha para navegar entre las entradas del menú"
                />
            </div>
        </div>
    );
};


export default PortfolioMenu;